import React from "react";

import "./BackToProjectsButton.scss";

type Props = {
  onClick: () => void;
};

const BackIcon = (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 6l-6 6l6 6" />
  </svg>
);

export const BackToProjectsButton = React.memo(({ onClick }: Props) => {
  return (
    <button
      type="button"
      className="dropdown-menu-button main-menu-trigger back-to-projects-btn"
      title="返回项目"
      aria-label="返回项目"
      onClick={onClick}
    >
      {BackIcon}
    </button>
  );
});
